import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import moment from "moment";
// import { getCityState } from "../../../../action/user_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { axiosInstnace } from "../../../util/util";
import { endPoints } from "../../../config";
import { putServerDataWithPath } from "../../../action/common_action";

class EditToOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timebands: [],
      total: {},
      months: "",
      endDate: props.endDate,
      specialComments: "",
      salesUserSapID: "",
      salesuserId: "",
      crmno: "",
      days: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ],
      indivrodps: props.campaign.indivrodps
        ? JSON.parse(props.campaign.indivrodps)
        : {},
    };
  }
  componentDidMount = () => {
    this.calculateTimes();
  };

  submitTrafficOrder = async (e) => {
    e.preventDefault();
    var formdata = {
      campaignId: this.props.campaign._id,
      clientName: this.props.client.clientName,
      clientAddress: this.props.campaign.kycDetails[0]
        ? this.props.campaign.kycDetails[0].billing_Address
        : "",
        nonFCTDescription: this.props.campaign.nonFCT.length > 0 ? this.props.campaign.nonFCT[0].description: "",
      clientBrand: this.props.client.clientBrand,
      clientStation: this.props.client.clientStation,
      station: this.props.campaign.station.includes(",")
        ? "Multiple (Refer Annexure)"
        : this.props.campaign.station,
      stations: this.props.campaign.station.split(",").map((e) => {
        return { name: e };
      }),
      startDate: moment(this.props.campaign.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      timebands: this.state.timebands,
      total: this.state.total,
      seconds: this.props.campaign.secondages,
      toMonth: this.state.months,
      totalCost: "",
      netRevenue: !this.props.campaign.audioRefundAmount
        ? this.props.campaign.packageCost + this.props.campaign.audioCost
        : this.state.packageCost,
      netRevenueTax: !this.props.campaign.audioRefundAmount
        ? (this.props.campaign.packageCost + this.props.campaign.audioCost) *
          0.18
        : this.state.packageCost * 0.18,
      totalRevenue: !this.props.campaign.audioRefundAmount
        ? this.props.campaign.totalCost
        : this.state.packageCost,
      audioDuration: this.props.campaign.audioDuration,
      salesUserId:
        this.props.campaign.salesUserDetails &&
        this.props.campaign.salesUserDetails.length > 0
          ? this.props.campaign.salesUserDetails[0].name
          : this.state.salesuserId,
      salesUserSapID: this.state.salesUserSapID,
      specialComments: this.state.specialComments,
      crmno: this.state.crmno,
    };

    let slots =
      this.props.campaign && this.props.campaign.timebands
        ? this.props.campaign.timebands.split(",")
        : ["07:00-22:00"];
    let slot = Math.floor(
      this.props.campaign.secondages /
        this.props.campaign.days /
        this.props.campaign.audioDuration /
        formdata.stations.length
    );

    /* if(this.props.campaign.isMultiDurationAudio == 'true'){
      slot = Math.floor(
        this.props.campaign.secondages /
          this.props.campaign.days /
          this.props.campaign.audioDuration /
          formdata.stations.length
      );
    } */
    debugger
    let errorStations = [];
    for (const station of formdata.stations) {
      let indivtimebands = formdata.timebands.filter((e) => {
        return e.station && e.station === station.name;
      });

      let total = indivtimebands.reduce((total, e) => {
        return e.total + total;
      }, 0);
      if (total !== slot * this.props.campaign.days) {
        errorStations.push(station.name);
      }
    }
    if (errorStations.length > 0 && this.props.campaign.isMultiDurationAudio != 'true') {
      alert(
        `Slot are mismatched in the stations ${JSON.stringify(
          errorStations
        )}, total No of slots per Station should be ${slot *
          this.props.campaign.days}`
      );
      return;
    }
    for (const timeband of formdata.timebands) {
      let rodp;
      let extradiscount = 1-( this.props.campaign.packageCost / this.props.campaign.actualpackageCost);
            if (timeband.station && this.state.indivrodps[timeband.station]) {
        let stationrate = this.state.indivrodps[timeband.station] * 10;
        let actualrate =
          stationrate -
          (stationrate * this.props.campaign.additionalBenefits) / 100;
        rodp = (actualrate - actualrate * extradiscount).toFixed(2);
      } else {
        rodp = (
          (this.props.campaign.packageCost / this.props.campaign.secondages) *
          10
        ).toFixed(2);
      }
      timeband.rate = timeband.total ? rodp : "";
      timeband.audioDuration = (timeband.total && this.props.campaign.isMultiDurationAudio != 'true')
        ? this.props.campaign.audioDuration
        : this.props.campaign.isMultiDurationAudio == 'true' ? timeband.audioDuration : "";
      timeband.fcttotal = timeband.total * (this.props.campaign.isMultiDurationAudio == 'true' ? timeband.audioDuration : this.props.campaign.audioDuration);
      timeband.spotrate = timeband.total
        ? (timeband.rate / 10) * (this.props.campaign.isMultiDurationAudio == 'true' ? timeband.audioDuration : this.props.campaign.audioDuration)
        : "";
      timeband.amount = timeband.total * timeband.spotrate;
      timeband.amount =
        timeband.month === "Audio"
          ? this.props.campaign.audioCost
          : timeband.month === "Non FCT"?
          this.props.campaign.nonFCTCodeAmount:
           timeband.amount;
      timeband.caption =
        timeband.month === "Audio" ? "Audio Production cost(NFCT)" : timeband.month === "Non FCT"? "Non FCT Cost" :"";
    }
    if(this.props.campaign.isMultiDurationAudio == 'true'){
      formdata.timebands.reduce( (totalFCT, timeband)=>{
        if(timeband.total && timeband.fcttotal){
          return (totalFCT += timeband.fcttotal);
        }else{
          return totalFCT;
        }
      }, 0);
    }else{
      formdata.total.fcttotal = formdata.total.total * this.props.campaign.audioDuration;
    }
    
    formdata.total.amount = formdata.timebands.reduce((amount, timeband) => {
      return amount + timeband.amount;
    }, 0);
    await this.props.updateContractToCampaign(
      endPoints.uploadTrafficOrder,
      formdata,
      "/admin/campaign"
    );
    this.props.getCampaignlist()
    this.props.hideUploadContract()
  };

  calculateTimes = () => {
    if (this.props.campaign) {
      if (
        this.props.campaign.couponDiscount &&
        this.props.campaign.couponPercentage
      ) {
        this.setState({
          specialComments: `Discount Coupon applied for ${this.props.campaign.couponPercentage}% and the discounted amount is ${this.props.campaign.couponDiscount}/- `,
        });
      } else if (
        this.props.campaign.couponDiscount &&
        !this.props.campaign.couponPercentage
      ) {
        this.setState({
          specialComments: `Discount Coupon applied for the flat rate of ${this.props.campaign.couponDiscount}/-`,
        });
      }
      let startDate = moment(this.props.campaign.startDate);
      let definedendDate = moment(this.props.campaign.startDate).add(
        this.props.campaign.days - 1,
        "days"
      );
      if (!this.props.endDate || definedendDate > this.props.endDate) {
        this.setState({
          endDate: definedendDate,
        });
      }
      let endDate =
        this.props.endDate && this.props.endDate > definedendDate
          ? moment(this.props.endDate)
          : definedendDate;
      var timeValues = [];
      while (
        endDate > startDate ||
        startDate.format("M") === endDate.format("M")
      ) {
        timeValues.push(startDate.format("MMM `YY"));
        startDate.add(1, "month");
      }
      startDate = moment(this.props.campaign.startDate);
      endDate =
        this.props.endDate && this.props.endDate > definedendDate
          ? moment(this.props.endDate)
          : definedendDate;
      let slots =
        this.props.campaign && this.props.campaign.timebands
          ? this.props.campaign.timebands.split(",")
          : ["07:00-22:00"];
      let stations = this.props.campaign.station.split(",");

      let dayseconds = Math.floor(
        this.props.campaign.secondages /
          this.props.campaign.days /
          this.props.campaign.audioDuration /
          slots.length /
          stations.length
      );

      let timebands = [];
      let daysstructure = undefined;
      let pushstructure = {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
        "6": "",
        "7": "",
        "8": "",
        "9": "",
        "10": "",
        "11": "",
        "12": "",
        "13": "",
        "14": "",
        "15": "",
        "16": "",
        "17": "",
        "18": "",
        "19": "",
        "20": "",
        "21": "",
        "22": "",
        "23": "",
        "24": "",
        "25": "",
        "26": "",
        "27": "",
        "28": "",
        "29": "",
        "30": "",
        "31": "",
        total: "",
      };
      let total = {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
        "15": 0,
        "16": 0,
        "17": 0,
        "18": 0,
        "19": 0,
        "20": 0,
        "21": 0,
        "22": 0,
        "23": 0,
        "24": 0,
        "25": 0,
        "26": 0,
        "27": 0,
        "28": 0,
        "29": 0,
        "30": 0,
        "31": 0,
        total: 0,
        fcttotal: 0,
        amtTotal: 0,
        mon: "",
        station: "",
      };

      if(this.props.campaign.isMultiDurationAudio != 'true'){
        daysstructure = { ...pushstructure };
        for (const station of stations) {
          for (
            var m = moment(startDate);
            m.diff(endDate, "days") <= 0;
            m.add(1, "days")
          ) {
            if (
              m.get("date") === 1 ||
              moment(m).format("YYYYMMDD") ===
                moment(startDate).format("YYYYMMDD")
            ) {
              timebands.push({
                ...daysstructure,
                ...{ month: station },
              });
              timebands.push({
                ...daysstructure,
                ...{ month: moment(m).format("MMMM") },
              });
              if (
                moment(m).format("YYYYMMDD") >
                moment(definedendDate).format("YYYYMMDD")
              ) {
                daysstructure[m.get("date")] = 0;
              } else {
                daysstructure[m.get("date")] = dayseconds;
              }
              daysstructure.total = daysstructure.total
                ? daysstructure.total + daysstructure[m.get("date")]
                : daysstructure[m.get("date")];
              total[m.get("date")] =
                daysstructure[m.get("date")] + total[m.get("date")];
  
              total.total = total.total + total[m.get("date")];
              if (
                moment(m).format("YYYYMMDD") ===
                moment(endDate).format("YYYYMMDD")
              ) {
                slots.map((slot, index) => {
                  if (index !== slots.length - 1) {
                    timebands.push({
                      ...daysstructure,
                      ...{ month: slot },
                      ...{ mon: moment(m).format("MM") },
                    });
                    if (index !== 0) {
                      for (const key in total) {
                        total[key] = daysstructure[key]
                          ? total[key] + daysstructure[key]
                          : total[key];
                      }
                    }
                  } else {
                    let diff =
                      Math.ceil(
                        this.props.campaign.secondages /
                          this.props.campaign.days /
                          this.props.campaign.audioDuration /
                          slots.length
                      ) -
                      Math.floor(
                        this.props.campaign.secondages /
                          this.props.campaign.days /
                          this.props.campaign.audioDuration /
                          slots.length
                      );
                    let modifiedstructure = { ...daysstructure };
                    for (const key in modifiedstructure) {
                      if (key !== "total") {
                        modifiedstructure[key] = modifiedstructure[key]
                          ? modifiedstructure[key] + diff
                          : modifiedstructure[key];
                        modifiedstructure.total = modifiedstructure[key]
                          ? modifiedstructure.total + diff
                          : modifiedstructure.total;
                      }
                    }
                    timebands.push({
                      ...modifiedstructure,
                      ...{ month: slot },
                      ...{ mon: moment(m).format("MM") },
                    });
                    if (index !== 0) {
                      for (const key in total) {
                        total[key] = modifiedstructure[key]
                          ? total[key] + modifiedstructure[key]
                          : total[key];
                      }
                    }
                  }
                });
                daysstructure = { ...pushstructure };
              }
            } else if (
              m.get("date") !==
                moment(m)
                  .endOf("M")
                  .get("date") &&
              (moment(m).format("YYYYMMDD") <
                moment(definedendDate).format("YYYYMMDD") ||
                (moment(m).format("YYYYMMDD") ===
                  moment(definedendDate).format("YYYYMMDD") &&
                  definedendDate !== endDate))
            ) {
              daysstructure[m.get("date")] = dayseconds;
              daysstructure.total = daysstructure.total
                ? daysstructure.total + daysstructure[m.get("date")]
                : daysstructure[m.get("date")];
              total[m.get("date")] =
                daysstructure[m.get("date")] + total[m.get("date")];
              total.total = total.total + total[m.get("date")];
            } else if (
              m.get("date") !==
                moment(m)
                  .endOf("M")
                  .get("date") &&
              moment(m).format("YYYYMMDD") < moment(endDate).format("YYYYMMDD") &&
              moment(m).format("YYYYMMDD") >
                moment(definedendDate).format("YYYYMMDD")
            ) {
              daysstructure[m.get("date")] = 0;
              daysstructure.total = daysstructure.total
                ? daysstructure.total + daysstructure[m.get("date")]
                : daysstructure[m.get("date")];
              total[m.get("date")] =
                daysstructure[m.get("date")] + total[m.get("date")];
              total.total = total.total + total[m.get("date")];
            } else {
              if (
                moment(m).format("YYYYMMDD") >
                moment(definedendDate).format("YYYYMMDD")
              ) {
                daysstructure[m.get("date")] = 0;
              } else {
                daysstructure[m.get("date")] = dayseconds;
              }
              daysstructure.total = daysstructure.total
                ? daysstructure.total + daysstructure[m.get("date")]
                : daysstructure[m.get("date")];
              total[m.get("date")] =
                daysstructure[m.get("date")] + total[m.get("date")];
              total.total = total.total + total[m.get("date")];
  
              slots.map((slot, index) => {
                if (index !== slots.length - 1) {
                  timebands.push({
                    ...daysstructure,
                    ...{ month: slot },
                    ...{ mon: moment(m).format("MM"), ...{ station } },
                  });
                  if (index !== 0) {
                    for (const key in total) {
                      total[key] = daysstructure[key]
                        ? total[key] + daysstructure[key]
                        : total[key];
                    }
                  }
                } else {
                  let diff =
                    Math.ceil(
                      this.props.campaign.secondages /
                        this.props.campaign.days /
                        this.props.campaign.audioDuration /
                        slots.length
                    ) -
                    Math.floor(
                      this.props.campaign.secondages /
                        this.props.campaign.days /
                        this.props.campaign.audioDuration /
                        slots.length
                    );
                  let modifiedstructure = { ...daysstructure };
                  for (const key in modifiedstructure) {
                    if (key !== "total") {
                      modifiedstructure[key] = modifiedstructure[key]
                        ? modifiedstructure[key] + diff
                        : modifiedstructure[key];
                      modifiedstructure.total = modifiedstructure[key]
                        ? modifiedstructure.total + diff
                        : modifiedstructure.total;
                    }
                  }
                  timebands.push({
                    ...modifiedstructure,
                    ...{ month: slot },
                    ...{ mon: moment(m).format("MM"), ...{ station } },
                  });
                  if (index !== 0) {
                    for (const key in total) {
                      total[key] = modifiedstructure[key]
                        ? total[key] + modifiedstructure[key]
                        : total[key];
                    }
                  }
                }
              });
              daysstructure = { ...pushstructure };
            }
          }
        }
      }else{
        let multiDurationAudioDetail = this.props.campaign.multidurationAudioDetail;
        if(multiDurationAudioDetail.length){
          daysstructure = { ...pushstructure };
          let updatedEndDate = endDate;

          for (const station of stations) {
            let slotsArray = [];
            let slotsInfoArray = [];
            let campaignDays = 0;

            for (
              var m = moment(startDate), daysIndex = 0;
              (m.diff(updatedEndDate, "days") <= 0 || daysIndex == 0);
              m.add(1, "days"), daysIndex += 1
            ) {
              if (
                m.get("date") === 1 ||
                moment(m).format("YYYYMMDD") ===
                  moment(startDate).format("YYYYMMDD")
              ) {
                if(slotsArray.length){
                  for (const slotsKey in slotsArray) {
                    if (Object.hasOwnProperty.call(slotsArray, slotsKey)) {
                      for (const mDurationAudioKey in slotsArray[slotsKey]) {
                        if (Object.hasOwnProperty.call(slotsArray[slotsKey], mDurationAudioKey)) {
                          timebands.push({
                            ...slotsArray[slotsKey][mDurationAudioKey],
                            month: slotsInfoArray[slotsKey][mDurationAudioKey].month,
                            mon: slotsInfoArray[slotsKey][mDurationAudioKey].mon,
                            ...{ station }
                          });
                        }
                      }
                    }
                  }

                  timebands.push({
                    ...daysstructure,
                    ...{ month: station },
                  });
                  timebands.push({
                    ...daysstructure,
                    ...{ month: moment(m).format("MMMM") },
                  });
                  
                  slotsArray = [];
                  slotsInfoArray = [];
                }else{
                  timebands.push({
                    ...daysstructure,
                    ...{ month: station },
                  });
                  timebands.push({
                    ...daysstructure,
                    ...{ month: moment(m).format("MMMM") },
                  });
                }
              }


              slots.map((slot, index) => {
                if(!slotsArray[index]) {
                  slotsArray[index] = [];
                  slotsInfoArray[index] = [];
                }

                for (const multiDurationObjectKey in multiDurationAudioDetail) {
                  if (Object.hasOwnProperty.call(multiDurationAudioDetail, multiDurationObjectKey)) {
                    if(!slotsArray[index][multiDurationObjectKey]) {
                      slotsArray[index][multiDurationObjectKey] = {...daysstructure};
                      slotsInfoArray[index][multiDurationObjectKey] = { month : `Audio ${parseInt(multiDurationObjectKey) + 1} \n ${slot}`, mon: moment(m).format("MM") };
                    }

                    let multiDurationAudios = multiDurationAudioDetail[multiDurationObjectKey];

                    if(daysIndex >= parseInt(multiDurationAudioDetail[multiDurationObjectKey].numberOfDays)) continue;
                    let dayStructureDate = m.get("date");
                    let multiAudioRotationsPerDay = parseInt(multiDurationAudios.rotationsPerDay.trim());
                    let slotsLength = slots.length;
                    let currentSlotRotations = Math.round(multiAudioRotationsPerDay / slotsLength);
                    let slotModulo = multiAudioRotationsPerDay % slotsLength;

                    if(slotModulo == 0 || (slotsLength - 1 != index)){ /* if equally divided or not last slot */
                      slotsArray[index][multiDurationObjectKey][dayStructureDate] = currentSlotRotations;
                    }else if(slotsLength - 1 == index){
                      currentSlotRotations = Math.abs(slotModulo - currentSlotRotations);
                    }
                    slotsArray[index][multiDurationObjectKey][dayStructureDate] = currentSlotRotations;
                    slotsArray[index][multiDurationObjectKey].total = (slotsArray[index][multiDurationObjectKey].total ? slotsArray[index][multiDurationObjectKey].total : 0) + slotsArray[index][multiDurationObjectKey][dayStructureDate];
                    total[dayStructureDate] = (total[dayStructureDate] ? total[dayStructureDate] : 0)  + slotsArray[index][multiDurationObjectKey][dayStructureDate];
                    total.total = (total.total ? total.total : 0) + total[dayStructureDate];

                    slotsArray[index][multiDurationObjectKey].audioDuration = multiDurationAudios.audioLength;
                  }

                  if(daysIndex == 0 && campaignDays == 0){
                    campaignDays = parseInt(multiDurationAudioDetail[multiDurationObjectKey].numberOfDays);
                  }else if(parseInt(multiDurationAudioDetail[multiDurationObjectKey].numberOfDays) > campaignDays){
                    let addToCampaignDays = parseInt(multiDurationAudioDetail[multiDurationObjectKey].numberOfDays) - campaignDays;
                    campaignDays += addToCampaignDays;
                  }
                }
                
              });

              if(daysIndex == 0){
                updatedEndDate = moment(startDate).add( campaignDays - 1, "days");
                this.setState({
                  endDate: updatedEndDate,
                });
              }
            }

            for (const slotsKey in slotsArray) {
              if (Object.hasOwnProperty.call(slotsArray, slotsKey)) {
                for (const mDurationAudioKey in slotsArray[slotsKey]) {
                  if (Object.hasOwnProperty.call(slotsArray[slotsKey], mDurationAudioKey)) {
                    timebands.push({
                      ...slotsArray[slotsKey][mDurationAudioKey],
                      month: slotsInfoArray[slotsKey][mDurationAudioKey].month,
                      mon: slotsInfoArray[slotsKey][mDurationAudioKey].mon,
                      ...{ station }
                    });
                  }
                }
              }
            }
          }
        }
        
      }




      if(this.props.campaign.isMultiDurationAudio == 'true'){
        let multiDurationAudio = this.props.campaign.multidurationAudioDetail;
        let toPrependSpecialComments = '';
        for (const multiDurationAudioKey in multiDurationAudio) {
          if (Object.hasOwnProperty.call(multiDurationAudio, multiDurationAudioKey)) {
            toPrependSpecialComments += `\nAudio ${parseInt(multiDurationAudioKey) + 1}: ${multiDurationAudio[multiDurationAudioKey].audio} (${multiDurationAudio[multiDurationAudioKey].audioLength} Seconds)`;
          }
        }

        this.setState({
          specialComments: this.state.specialComments + toPrependSpecialComments,
        });
      }

      if (
        this.props.campaign.audioCost &&
        (!this.props.campaign.audioRefundAmount ||
          this.props.campaign.audioRefundAmount === "0")
      ) {
        daysstructure = { ...pushstructure };
        daysstructure["1"] = 1;
        daysstructure.total = 0;
        timebands.push({
          ...daysstructure,
          ...{ month: "Audio" },
        });
      }
      if (
        this.props.campaign.nonFCTCodeAmount &&
        this.props.campaign.nonFCTCodeAmount > 0 
      ) {
        daysstructure = { ...pushstructure };
        daysstructure["1"] = 1;
        daysstructure.total = 0;
        timebands.push({
          ...daysstructure,
          ...{ month: "Non FCT" },
        });
      }
      total.total = this.state.days.reduce((totalamt, day) => {
        return totalamt + total[day];
      }, 0);
      total.fcttotal = timebands.reduce((fctamout, timeband) => {
        if(timeband.total){
          if(this.props.campaign.isMultiDurationAudio == 'true'){
            return fctamout + timeband.total * timeband.audioDuration;
          }else{
            return fctamout + timeband.total * this.props.campaign.audioDuration;
          }
        }
        else{
          return fctamout;
        }
      }, 0);
      total.amtTotal = timebands.reduce((fctamout, timeband) => {
        let rodp;
        let extradiscount = 1-( this.props.campaign.packageCost / this.props.campaign.actualpackageCost);
        if (timeband.station && this.state.indivrodps[timeband.station]) {
          let stationrate = this.state.indivrodps[timeband.station] * 10;
          let actualrate =
            stationrate -
            (stationrate * this.props.campaign.additionalBenefits) / 100;
          rodp = (actualrate - actualrate * extradiscount).toFixed(2);
        } else {
          rodp = (
            (this.props.campaign.packageCost / this.props.campaign.secondages) *
            10
          ).toFixed(2);
        }
        if(timeband.total){
          if(this.props.campaign.isMultiDurationAudio == 'true'){
            return (
              fctamout +
              ((rodp * timeband.audioDuration) / 10) * timeband.total
            );
          }else{
            return (
              fctamout +
              ((rodp * this.props.campaign.audioDuration) / 10) * timeband.total
            );
          }
        }else{
          return fctamout;
        }
        
      }, 0);
      if (
        this.props.campaign.audioCost &&
        !this.props.campaign.audioRefundAmount
      ) {
        total.amtTotal = total.amtTotal + this.props.campaign.audioCost;
      }
      if (
        this.props.campaign.nonFCTCodeAmount &&
        this.props.campaign.nonFCTCodeAmount > 0
      ) {
        total.amtTotal = total.amtTotal + this.props.campaign.nonFCTCodeAmount;
      }
      this.setState({
        timebands,
        total,
        months: timeValues,
      });
    }
  };
  changeValues = (station, month, range, date, value) => {
    let { timebands, total } = this.state;
    let monthtimeband = timebands.find((e) => {
      return e.mon === month && e.month === range && e.station === station;
    });
    total[date] = value
      ? total[date] - monthtimeband[date] + parseInt(value)
      : total[date] - monthtimeband[date];
    total.total = value
      ? total.total - monthtimeband[date] + parseInt(value)
      : total.total - monthtimeband[date];
    monthtimeband.total = value
      ? monthtimeband.total - monthtimeband[date] + parseInt(value)
      : monthtimeband.total - monthtimeband[date];
    monthtimeband[date] = value ? parseInt(value) : "";
    total.fcttotal = timebands.reduce((fctamout, timeband) => {
      if(this.props.campaign.isMultiDurationAudio == 'true')
        return (timeband.audioDuration && timeband.total) ? fctamout + timeband.total * timeband.audioDuration : fctamout;
      else
        return fctamout + timeband.total * this.props.campaign.audioDuration;
    }, 0);
    total.amtTotal = timebands.reduce((fctamout, timeband) => {
      let rodp;
      let extradiscount = 1-( this.props.campaign.packageCost / this.props.campaign.actualpackageCost);
      if (timeband.station && this.state.indivrodps[timeband.station]) {
        let stationrate = this.state.indivrodps[timeband.station] * 10;
        let actualrate =
          stationrate -
          (stationrate * this.props.campaign.additionalBenefits) / 100;
        rodp = (actualrate - actualrate * extradiscount).toFixed(2)
      } else {
        rodp = (
          (this.props.campaign.packageCost / this.props.campaign.secondages) *
          10
        ).toFixed(2);
      }
      if(this.props.campaign.isMultiDurationAudio == 'true'){
        if(timeband.audioDuration && timeband.total){
          return (
            fctamout +
            ((rodp * timeband.audioDuration) / 10) * timeband.total
          );
        }else{
          return;
        }
      }
      else 
        return (
          fctamout +
          ((rodp * this.props.campaign.audioDuration) / 10) * timeband.total
        );
    }, 0);
    if (
      this.props.campaign.audioCost &&
      !this.props.campaign.audioRefundAmount
    ) {
      total.amtTotal = total.amtTotal + this.props.campaign.audioCost;
    }
    if (
      this.props.campaign.nonFCTCodeAmount &&
      this.props.campaign.nonFCTCodeAmount > 0
    ) {
      total.amtTotal = total.amtTotal + this.props.campaign.nonFCTCodeAmount;
    }
    this.setState({
      timebands,
    });
  };
  render() {
    return (
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
          style={{ height: "80vh", overflow: "auto" }}
        >
          <div className="modal approval" style={{ width: "100%" }}>
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={this.props.hideUploadContract}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{margin:"10px"}}> */}{" "}
              <table cellSpacing="0" border="0" id="TrafficOrder">
                <colgroup width="141"></colgroup>
                <colgroup width="323"></colgroup>
                <colgroup span="8" width="36"></colgroup>
                <colgroup span="20" width="42"></colgroup>
                <colgroup span="3" width="36"></colgroup>
                <colgroup width="71"></colgroup>
                <colgroup width="79"></colgroup>
                <colgroup width="114"></colgroup>
                <colgroup width="137"></colgroup>
                <colgroup width="86"></colgroup>
                <colgroup width="92"></colgroup>
                <tbody>
                  <tr>
                    <td
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="39"
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TRAFFIC ORDER / SCHEDULE
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="12"
                      height="31"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Client Details
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="19"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Campaign Details
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="3"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TO Details
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                      }}
                      colSpan="2"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Client
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="10"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.props.client && this.props.client.clientName}
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="6"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Sales Offc. /Station
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="13"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000">
                        {this.props.client && this.props.client.clientStation}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TO for Month
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;1033;[$-409]MMM-YY;@"
                    >
                      <font size="3" color="#000000">
                        {this.state.months && this.state.months.join(",")}
                      </font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderBottom: "1px solid #000000",
                      }}
                      colSpan="2"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Address
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="10"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000">
                        {this.props.campaign &&
                          this.props.campaign.kycDetails[0] &&
                          this.props.campaign.kycDetails[0].billing_Address}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="6"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Running Stations
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="13"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.props.campaign &&
                          this.props.campaign.station.includes(",")
                            ? "Multiple (Refer Annexure)"
                            : this.props.campaign.station}
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Cart IDs Rqrd
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderTop: "1px solid #000000",
                      }}
                      colSpan="2"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Product / Brand
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="10"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000">
                        {this.props.client && this.props.client.clientBrand}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="6"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Start Date
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="13"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;1033;[$-409]D-MMM-YY;@"
                    >
                      <font size="3" color="#000000">
                        {this.props.campaign &&
                          this.props.campaign.startDate &&
                          moment(this.props.campaign.startDate).format(
                            "YYYY-MM-DD"
                          )}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Total Seconds
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdnum="1033;0;#,##0"
                    >
                      <font size="3" color="#000000">
                        {this.props.campaign && this.props.campaign.secondages}
                      </font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderTop: "1px solid #000000",
                      }}
                      colSpan="2"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Agency
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="10"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="6"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          End Date
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="13"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;1033;[$-409]D-MMM-YY;@"
                    >
                      <font size="3" color="#000000">
                        {moment(this.state.endDate).format("YYYY-MM-DD")}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Net Revenue
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.props.campaign && this.props.campaign.packageCost}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="14"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="16"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="2"
                      rowSpan="2"
                      height="39"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          CRM QUOTE NO
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="5"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                    >
                      <font size="3" color="#000000">
                        <input
                          value={this.state.crmno}
                          onChange={(e) => {
                            this.setState({
                              crmno: e.target.value,
                            });
                          }}
                        />
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="13"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      height="42"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Timeband
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Caption
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="1"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          1
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="2"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          2
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="3"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          3
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="4"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          4
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="5"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          5
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="6"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          6
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="7"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          7
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="8"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          8
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="9"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          9
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="10"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          10
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="11"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          11
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="12"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          12
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="13"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          13
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="14"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          14
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="15"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          15
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="16"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          16
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="17"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          17
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="18"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          18
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="19"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          19
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="20"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          20
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="21"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          21
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="22"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          22
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          23
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="24"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          24
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="25"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          25
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="26"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          26
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="27"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          27
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="28"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          28
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="29"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          29
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="30"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          30
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="31"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          31
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          No.ofspots
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          SpotDur.
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          FCT
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#BFBFBF"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Gross/Net Rate(Per 10 Secs)
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#BFBFBF"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Per SpotCost
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#BFBFBF"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Amount
                        </font>
                      </b>
                    </td>
                  </tr>
                  {this.state.timebands &&
                    this.state.timebands.map((timeband) => {
                      let rodp;
                      let extradiscount = 1 -
                        (this.props.campaign.packageCost /
                        this.props.campaign.actualpackageCost);
                      if (
                        timeband.station &&
                        this.state.indivrodps[timeband.station]
                      ) {
                        let stationrate =
                          this.state.indivrodps[timeband.station] * 10;
                        let actualrate =
                          stationrate -
                          (stationrate *
                            this.props.campaign.additionalBenefits) /
                            100;
                        rodp = (
                          actualrate - actualrate * extradiscount
                        ).toFixed(2);
                      } else {
                        rodp = (
                          (this.props.campaign.packageCost /
                            this.props.campaign.secondages) *
                          10
                        ).toFixed(2);
                      }
                      return (
                        <React.Fragment>
                          <tr>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "2px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              height="27"
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  {timeband.month}
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000"></font>
                            </td>

                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 1 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        1)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 1)) && (
                                    <input
                                      value={
                                        timeband["1"] > 0 ? timeband["1"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          1,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                                {timeband.month === "Audio" && timeband["1"]}
                                  {timeband.month === "Non FCT" && timeband["1"]}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 2 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        2)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 2)) && (
                                    <input
                                      value={
                                        timeband["2"] > 0 ? timeband["2"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          2,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 3 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        3)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 3)) && (
                                    <input
                                      value={
                                        timeband["3"] > 0 ? timeband["3"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          3,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 4 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        4)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 4)) && (
                                    <input
                                      value={
                                        timeband["4"] > 0 ? timeband["4"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          4,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 5 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        5)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 5)) && (
                                    <input
                                      value={
                                        timeband["5"] > 0 ? timeband["5"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          5,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 6 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        6)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 6)) && (
                                    <input
                                      value={
                                        timeband["6"] > 0 ? timeband["6"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          6,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 7 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        7)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 7)) && (
                                    <input
                                      value={
                                        timeband["7"] > 0 ? timeband["7"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          7,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 8 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        8)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 8)) && (
                                    <input
                                      value={
                                        timeband["8"] > 0 ? timeband["8"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          8,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 9 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        9)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 9)) && (
                                    <input
                                      value={
                                        timeband["9"] > 0 ? timeband["9"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          9,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 10 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        10)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 10)) && (
                                    <input
                                      value={
                                        timeband["10"] > 0 ? timeband["10"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          10,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 11 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        11)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 11)) && (
                                    <input
                                      value={
                                        timeband["11"] > 0 ? timeband["11"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          11,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 12 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        12)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 12)) && (
                                    <input
                                      value={
                                        timeband["12"] > 0 ? timeband["12"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          12,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 13 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        13)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 13)) && (
                                    <input
                                      value={
                                        timeband["13"] > 0 ? timeband["13"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          13,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 14 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        14)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 14)) && (
                                    <input
                                      value={
                                        timeband["14"] > 0 ? timeband["14"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          14,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 15 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        15)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 15)) && (
                                    <input
                                      value={
                                        timeband["15"] > 0 ? timeband["15"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          15,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 16 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        16)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 16)) && (
                                    <input
                                      value={
                                        timeband["16"] > 0 ? timeband["16"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          16,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 17 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        17)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 17)) && (
                                    <input
                                      value={
                                        timeband["17"] > 0 ? timeband["17"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          17,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 18 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        18)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 18)) && (
                                    <input
                                      value={
                                        timeband["18"] > 0 ? timeband["18"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          18,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 19 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        19)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 19)) && (
                                    <input
                                      value={
                                        timeband["19"] > 0 ? timeband["19"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          19,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 20 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        20)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 20)) && (
                                    <input
                                      value={
                                        timeband["20"] > 0 ? timeband["20"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          20,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 21 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        21)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 21)) && (
                                    <input
                                      value={
                                        timeband["21"] > 0 ? timeband["21"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          21,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 22 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        22)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 22)) && (
                                    <input
                                      value={
                                        timeband["22"] > 0 ? timeband["22"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          22,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 23 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        23)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 23)) && (
                                    <input
                                      value={
                                        timeband["23"] > 0 ? timeband["23"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          23,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 24 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        24)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 24)) && (
                                    <input
                                      value={
                                        timeband["24"] > 0 ? timeband["24"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          24,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 25 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        25)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 25)) && (
                                    <input
                                      value={
                                        timeband["25"] > 0 ? timeband["25"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          25,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 26 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        26)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 26)) && (
                                    <input
                                      value={
                                        timeband["26"] > 0 ? timeband["26"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          26,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 27 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        27)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 27)) && (
                                    <input
                                      value={
                                        timeband["27"] > 0 ? timeband["27"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          27,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 28 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        28)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 28)) && (
                                    <input
                                      value={
                                        timeband["28"] > 0 ? timeband["28"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          28,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 29 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        29)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 29)) && (
                                    <input
                                      value={
                                        timeband["29"] > 0 ? timeband["29"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          29,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 30 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        30)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 30)) && (
                                    <input
                                      value={
                                        timeband["30"] > 0 ? timeband["30"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          30,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#FFFFFF"
                            >
                              <font size="3" color="#000000">
                                {timeband.mon &&
                                  moment(timeband.mon, "MM")
                                    .endOf("month")
                                    .get("date") >= 31 &&
                                  (timeband.mon <
                                    moment(this.state.endDate).format("MM") ||
                                    (timeband.mon ==
                                      moment(this.state.endDate).format("MM") &&
                                      moment(this.state.endDate).get("date") >=
                                        31)) &&
                                  (timeband.mon >
                                    moment(
                                      this.props.campaign.startDate
                                    ).format("MM") ||
                                    (timeband.mon ==
                                      moment(
                                        this.props.campaign.startDate
                                      ).format("MM") &&
                                      moment(this.props.campaign.startDate).get(
                                        "date"
                                      ) <= 31)) && (
                                    <input
                                      value={
                                        timeband["31"] > 0 ? timeband["31"] : ""
                                      }
                                      style={{ width: "25px" }}
                                      type="number"
                                      onChange={(e) => {
                                        this.changeValues(
                                          timeband.station,
                                          timeband.mon,
                                          timeband.month,
                                          31,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  )}
                              </font>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#D9D9D9"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  {timeband.total && Math.round(timeband.total)}
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#D9D9D9"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  { (timeband.total && timeband.month !== "Audio" && this.props.campaign && this.props.campaign.isMultiDurationAudio != 'true') ? this.props.campaign.audioDuration :  (this.props.campaign.isMultiDurationAudio == 'true' && timeband.audioDuration) ? timeband.audioDuration : ''}
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#D9D9D9"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  { (this.props.campaign && timeband.month !== "Audio" && this.props.campaign.isMultiDurationAudio != 'true') ?  
                                      (timeband.total * this.props.campaign.audioDuration) 
                                      : 
                                      ((this.props.campaign.isMultiDurationAudio == 'true' && timeband.total) ? (timeband.total * timeband.audioDuration) : 0)
                                  }
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "1px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#C0C0C0"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  {timeband.total &&
                                    timeband.month !== "Audio" &&
                                    rodp}
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "2px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#C0C0C0"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  { (timeband.total && timeband.month !== "Audio" && this.props.campaign.isMultiDurationAudio != 'true') ?
                                    ((rodp * this.props.campaign.audioDuration) / 10).toFixed(2) : (this.props.campaign.isMultiDurationAudio == 'true' && timeband.total) ? ((rodp * timeband.audioDuration) / 10).toFixed(2) : 0}
                                </font>
                              </b>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #000000",
                                borderBottom: "1px solid #000000",
                                borderLeft: "1px solid #000000",
                                borderRight: "2px solid #000000",
                              }}
                              align="center"
                              valign="middle"
                              bgcolor="#C0C0C0"
                            >
                              <b>
                                <font size="3" color="#000000">
                                  { timeband.month !== "Audio" && timeband.month !== "Non FCT" && this.props.campaign.isMultiDurationAudio != 'true' ?
                                    (Math.round(
                                      ((rodp *
                                        this.props.campaign.audioDuration) /
                                        10) *
                                        timeband.total
                                    )) : (this.props.campaign.isMultiDurationAudio == 'true' && timeband.audioDuration)? 
                                        (Math.round(
                                          ((rodp *
                                            timeband.audioDuration) /
                                            10) *
                                            timeband.total
                                        )) : ''
                                  }
                                  {timeband.month === "Audio" &&
                                    this.props.campaign.audioCost}
                                                                      {timeband.month === "Non FCT" &&
                                    this.props.campaign.nonFCTCodeAmount}
                                </font>
                              </b>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}

                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="2"
                      height="35"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TOTAL
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["1"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["2"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["3"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["4"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["5"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["6"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["7"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["8"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["9"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["10"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["11"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["12"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["13"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["14"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["15"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="0"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["16"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["17"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["18"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["19"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["20"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["21"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["22"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["23"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["24"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["25"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["26"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["27"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["28"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["29"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["30"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="23"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total["31"]}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="690"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {this.state.total.total}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="10350"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.fcttotal &&
                            this.props.campaign &&
                            this.props.campaign.secondages}
                          {this.state.total.fcttotal > 0 &&
                            this.state.total.fcttotal}
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="45000"
                      sdnum="1033;"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            !this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageCost +
                              this.props.campaign.audioCost}
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageCost}
                          {this.state.total.amtTotal > 0 &&
                            Math.round(this.state.total.amtTotal)}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="19"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Special Instructions
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="13"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Sales Associate Details
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Agency Commission
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="0"
                      sdnum="1033;0;0.00%"
                    >
                      <b>
                        <font size="3" color="#FF0000">
                          0.00%
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="0"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          0
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="19"
                      rowSpan="6"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <textarea
                        style={{ width: "95%", height: "95%" }}
                        value={this.state.specialComments}
                        onChange={(e) => {
                          this.setState({
                            specialComments: e.target.value,
                          });
                        }}
                      ></textarea>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF"></td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TP Name / Mapped Station
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      align="center"
                      valign="middle"
                    >
                      <font size="3" color="#000000">
                        {this.props.campaign.salesUserDetails &&
                          this.props.campaign.salesUserDetails.length > 0 && 
                          this.props.campaign.salesUserDetails[0].mentorName ? `${this.props.campaign.salesUserDetails[0].mentorName} / ${this.props.campaign.salesUserDetails[0].mentorStation}` : ''
                        }
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="3"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Net Revenue
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                      sdval="45000"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            !this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageCost +
                              this.props.campaign.audioCost}
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageCost}
                          {this.state.total.amtTotal > 0 &&
                            Math.round(this.state.total.amtTotal)}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TP SAP ID
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <font size="3" color="#000000">
                        {" "}
                        <input
                          value={this.state.salesUserSapID}
                          onChange={(e) => {
                            this.setState({
                              salesUserSapID: e.target.value,
                            });
                          }}
                        ></input>
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                      rowSpan="2"
                    >
                      <b>
                        <font size="3" color="#000000">
                          S Tax
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="0.18"
                      sdnum="1033;0;0.00%"
                      rowSpan="2"
                    >
                      <b>
                        <font size="3" color="#FF0000">
                          18.00%
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="8100"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            !this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageTax +
                              this.props.campaign.audioTax}
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            this.props.campaign.audioRefundAmount &&
                            this.props.campaign.packageTax}
                          {this.state.total.amtTotal > 0 &&
                            Math.round(this.state.total.amtTotal * 0.18)}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr className="for-tp">
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Sales Associate Name
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      align="center"
                      valign="middle"
                    >
                      <font size="3" color="#000000">
                        {this.props.campaign.salesUserDetails &&
                          this.props.campaign.salesUserDetails.length > 0 &&
                          this.props.campaign.salesUserDetails[0].name}
                        {" "}
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr className="for-tp">
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Sales Associate SAP ID
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                    >
                      <font size="3" color="#000000">
                        {" "}
                        <input
                          value={this.state.salesUserSapID}
                          onChange={(e) => {
                            this.setState({
                              salesUserSapID: e.target.value,
                            });
                          }}
                        ></input>
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="3"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Amount
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="53100"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            this.props.campaign.totalCost}

                          {this.state.total.amtTotal > 0 &&
                            Math.round(
                              this.state.total.amtTotal +
                                Math.round(this.state.total.amtTotal * 0.18)
                            )}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Signature
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          TDS
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#F2DCDB"
                      sdval="0"
                      sdnum="1033;0;0.00%"
                    >
                      <b>
                        <font size="3" color="#FF0000">
                          0.00%
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                      sdval="0"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          0
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="19"
                      height="29"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="4"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Manager
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="9"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="3"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Total Amount
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#DCE6F2"
                      sdval="53100"
                      sdnum="1033;0;0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          {!this.state.total.amtTotal &&
                            this.props.campaign &&
                            this.props.campaign.totalCost}
                          {this.state.total.amtTotal > 0 &&
                            Math.round(
                              this.state.total.amtTotal +
                                Math.round(this.state.total.amtTotal * 0.18)
                            )}
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      colSpan="5"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="29"
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Spot/Creative/Audio Location
                        </font>
                      </b>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="3"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Chq. Amt.
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Chq No.
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000"></font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#C0C0C0"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Chq. Date
                        </font>
                      </b>
                    </td>
                    <td
                      style={{
                        borderTop: "2px solid #000000",
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#D9D9D9"
                    >
                      <b>
                        <font size="3" color="#000000">
                          Name of Bank
                        </font>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="29"
                      height="33"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000">
                        attached
                      </font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      colSpan="3"
                      align="center"
                      valign="middle"
                      sdnum="1033;0;0.00"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;0;@"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;0;@"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                      sdnum="1033;1033;[$-409]D-MMM-YY;@"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      colSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="21"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderLeft: "2px solid #000000" }}
                      height="21"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderBottom: "2px solid #000000" }}
                      colSpan="36"
                      rowSpan="2"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <i>
                        <font size="3" color="#FF0000">
                          Please do not edit in the colored cells/ do not delete
                          or edit farmule
                        </font>
                      </i>
                    </td>
                    <td align="center" valign="middle" bgcolor="#FFFFFF">
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderRight: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderLeft: "2px solid #000000",
                      }}
                      height="22"
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{ borderBottom: "2px solid #000000" }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                    <td
                      style={{
                        borderBottom: "2px solid #000000",
                        borderRight: "2px solid #000000",
                      }}
                      align="center"
                      valign="middle"
                      bgcolor="#FFFFFF"
                    >
                      <font size="3" color="#000000"></font>
                    </td>
                  </tr>
                </tbody>
              </table>
              {this.props.campaign.station.includes(",") && (
                <div
                  className="package_include style"
                  style={{ marginTop: "32px", marginBottom: "16px" }}
                >
                  <span style={{ fontSize: "16px", fontWeight: 500 }}>
                    Annexure I - List of Stations Booked:
                  </span>
                  <p />
                  {this.props.campaign.station.split(",").map((e, index) => {
                    return (
                      <p style={{ color: "#515151", fontSize: "14px" }}>
                        {index + 1}. {e}
                      </p>
                    );
                  })}
                  <p />
                </div>
              )}
              { (this.props.campaign.nonFCTCodeAmount && this.props.campaign.nonFCTCodeAmount > 0) ? (
                <div
                  className="package_include style"
                  style={{ marginTop: "32px", marginBottom: "16px" }}
                >
                  <span style={{ fontSize: "16px", fontWeight: 500 }}>
                    Annexure II - Non FCT Addons:
                  </span>
                  <p />
                  <p>{this.props.campaign.nonFCT[0].description}</p>
                  <p />
                </div>
              ): ''}

              <div>
                <button
                  onClick={(e) => {
                    this.props.showChangeEndDate();
                  }}
                  style={{ color: "white" }}
                >
                  Change End Date
                </button>
                <button
                  onClick={(e) => {
                    this.props.hideUploadContract();
                  }}
                  style={{ color: "white" }}
                >
                  Cancel
                </button>
                {!this.state.total.fcttotal && this.props.campaign && (
                  <button
                    style={{ color: "white" }}
                    onClick={this.submitTrafficOrder}
                  >
                    Submit
                  </button>
                )}
                {this.state.total.fcttotal > 0 &&
                  this.state.total.fcttotal ===
                    this.props.campaign.secondages && (
                    <button
                      style={{ color: "white" }}
                      onClick={this.submitTrafficOrder}
                    >
                      Submit
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// const mapStateToProps = state => ({ stateList: state.user.get('stateList') })

const mapStateToProps = (state) => {
  console.log(state);
  return {
    stateList: state.sales.get("stateList"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateContractToCampaign: (url, data, path) =>
      dispatch(putServerDataWithPath(url, data, path)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditToOrder);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/EditToOrder.jsx